/*
 * Copyright (c) 2020 - 2025 Ping Identity Corporation. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */
import { BaseCallback } from './base-callback.js';
/**
 * Represents a callback used to collect a password.
 */
export class PasswordCallback extends BaseCallback {
    payload;
    /**
     * @param payload The raw payload returned by OpenAM
     */
    constructor(payload) {
        super(payload);
        this.payload = payload;
    }
    /**
     * Gets the callback's failed policies.
     */
    getFailedPolicies() {
        return this.getOutputByName('failedPolicies', []);
    }
    /**
     * Gets the callback's applicable policies.
     */
    getPolicies() {
        return this.getOutputByName('policies', []);
    }
    /**
     * Gets the callback's prompt.
     */
    getPrompt() {
        return this.getOutputByName('prompt', '');
    }
    /**
     * Sets the password.
     */
    setPassword(password) {
        this.setInputValue(password);
    }
}
